import React, { Fragment, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import MainWrapper from "../../../MainWrapper";
import { Link, useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back  } from 'react-icons-kit/md';
import { Accordion, Table, Button, Row, Col, Form } from "react-bootstrap";
import { toast } from 'react-toastify';
import { FaTrash } from "react-icons/fa";
import ConfirmModal from "./ConfirmModal";
import EditRoleModal from "./EditRoleModal";
import axios from 'axios';
import { API_URL } from '../../../../config';

import {
  CUSTOMER_APPROVAL_LIST_REQUEST,
  CUSTOMER_APPROVAL_UPDATE_REQUEST,
  CUSTOMER_APPROVAL_REJECT_REQUEST,
  CUSTOMER_APPROVAL_DELETE_REQUEST,
  PROPERTY_LIST_REQUEST,
  ADD_NEW_PROPERTY_REQUEST,
  CUSTOMER_PROPERTY_DELETE_REQUEST,
  CUSTOMER_ROLE_UPDATE_REQUEST
} from "../../../../_utils/constants/CustomerApproval";
import { ROLE_LIST_REQUEST } from "../../../../_utils/constants/Role";
import Input from "../../../elements/CustomInput";

// Derive a Bootstrap badge style from the customer's approval status.
// Values come straight from the API (e.g. "Pending Request"); the status
// text itself is never hard-coded and unknown statuses fall back to a
// neutral badge, matching the inline `badge bg-*` styling used elsewhere.
const getStatusBadgeClass = (status) => {
  const value = (status || "").toLowerCase();
  if (value.includes("pending")) return "bg-warning text-dark";
  if (value.includes("reject")) return "bg-danger";
  if (value.includes("approv") || value.includes("active")) return "bg-success";
  return "bg-secondary";
};

const CustomerApproval = ({
  auth: { auth, isAuthenticated },
  CustomerApproval: { 
    customerApprovalList, 
    errors, 
    isLoading, 
    customerUpdationData, 
    customerRejectedData, 
    customerDeletedData,
    customerExistData,
    propertyList,
    propertyDeletedData,
    propertyUpdatedData,
    customerRoleUpdatedData
  },
  Role: { roleList },
  fetchCustomerApprovalList,
  updateCustomerApprovalStatus,
  rejectCustomerApprovalRequest,
  deleteCustomerApprovalRequest,
  fetchPropertyAlreadyExist,
  addNewProperty,
  deleteCustomerPropertyRequest,
  fetchRoleList,
  updateCustomerRole
}) => {

  //state declaration
  const [customerApprovalData, setCustomerApprovalData] = useState()
  const [listParamState, setListParamState] = useState({
		"firstName": "",
		"lastName": "",
		"email": "",
		"pageIndex": 0,
		"pageSize": 0
	});
  const [responseData, setResponseData] = useState()
  const [responseDeleteData, setResponseDeleteData] = useState()
  const [isLoaded, setIsLoaded] = useState(false)
  const approvedMessage = "Sign up request for customer is successfully approved. Email with verification link will be sent to customer."
  const rejectedMessage = "Sign up request is successfully rejected."
  // const [selectedPropertyIds, setSelectedPropertyIds] = useState([]) 
  const [tempRows, setTempRows] = useState({}); // {index: [rows]}
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProps, setFilteredProps] = useState([]);
  const [deletePropertyModalOpen, setDeletePropertyModalOpen] = useState(false);
  const [deleteCustomerModalOpen, setDeleteCustomerModalOpen] = useState(false);
  const [deletePropertyData, setDeletePropertyData] = useState({});
  const [deleteCustomerData, setDeleteCustomerData] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [editRoleModalOpen, setEditRoleModalOpen] = useState(false);
  const [editRoleData, setEditRoleData] = useState({});
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [approvedUsers, setApprovedUsers] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState({});
  // { [customerSignupPropertyId]: roleId } — tracks approver role selection per existing property
  const [propertyApproverRoles, setPropertyApproverRoles] = useState({});
  // These fields are returned inside `customerProperty`, so they are filtered
  // locally rather than being sent to the signup-request API.
  const [propertyFilters, setPropertyFilters] = useState({
    propertyName: "",
    managementCompany: ""
  });
  const navigate = useNavigate();

  // Customer roles available for the Edit Role dropdown
  const customerRoles = useMemo(
    () => (roleList || []).filter(role => role.roleType === "Customer"),
    [roleList]
  );

  // Employee roles for the per-property approver dropdown
  // const employeeRoles = useMemo(
  //   () => (roleList || []).filter(role => role.roleType === "Employee"),
  //   [roleList]
  // );

  const filteredCustomerApprovalData = useMemo(() => {
    const propertyNameFilter = propertyFilters.propertyName.trim().toLowerCase();
    const managementCompanyFilter = propertyFilters.managementCompany.trim().toLowerCase();

    return (customerApprovalData || []).reduce((customers, customer, customerIndex) => {
      const matchingProperties = (customer.customerProperty || []).filter(property => {
        const propertyName = (property.propertyName || "").toLowerCase();
        const managementCompany = (property.managementCompany || "").toLowerCase();

        return (!propertyNameFilter || propertyName.includes(propertyNameFilter)) &&
          (!managementCompanyFilter || managementCompany.includes(managementCompanyFilter));
      });

      if ((!propertyNameFilter && !managementCompanyFilter) || matchingProperties.length) {
        customers.push({
          ...customer,
          customerProperty: propertyNameFilter || managementCompanyFilter
            ? matchingProperties
            : customer.customerProperty,
          sourceIndex: customerIndex
        });
      }

      return customers;
    }, []);
  }, [customerApprovalData, propertyFilters]);

  // function to handle customer approval list api call
  useEffect(() => {
    if (!isAuthenticated) {
			navigate("/login")
		}
    if (isAuthenticated) {
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [isAuthenticated, auth, listParamState])

  // fetch role list for the Edit Role dropdown
  useEffect(() => {
    if (isAuthenticated) {
      fetchRoleList(auth[0].token)
    }
  }, [isAuthenticated, auth])

  // fetch confirmed/approved users for the Set Approver dropdown
  useEffect(() => {
    if (isAuthenticated && auth[0]?.token) {
      axios.get(
        `${API_URL}/User/api/Signup/GetSignupRequest?Email=&FirstName=&LastName=&PageIndex=0&PageSize=0`,
        { headers: { Authorization: `Bearer ${auth[0].token}` } }
      ).then(res => {
        const list = res?.data?.result || [];
        setApprovedUsers(
          list.filter(u => {
            const s = (u.status || "").toLowerCase();
            return s === "confirmed" || s === "approved";
          })
        );
      }).catch(() => {});
    }
  }, [isAuthenticated])

  // function to handle customer approval list
  useEffect(() => {
    setCustomerApprovalData(customerApprovalList)
    if (customerApprovalList && customerApprovalList.length > 0) {
      const roles = {};
      customerApprovalList.forEach(customer => {
        (customer.customerProperty || []).forEach(prop => {
          if (prop.customerSignupPropertyId && prop.approverRoleId) {
            roles[prop.customerSignupPropertyId] = String(prop.approverRoleId);
          }
        });
      });
      setPropertyApproverRoles(roles);
    }
  }, [customerApprovalList])

  // handle customer approval updation
  useEffect(() => {
    if(!_.isEmpty(customerUpdationData)) {
      setResponseData(customerUpdationData)
    }
  }, [customerUpdationData])

  // handle customer rejection
  useEffect(() => {
    if(!_.isEmpty(customerRejectedData)) {
      setResponseData(customerRejectedData)
    }
  }, [customerRejectedData])

  // handle response data
  useEffect(() => {
    if (customerExistData) {
      toast.error(customerExistData)
    }
  }, [customerExistData])

  //handle response data
  useEffect(() => {
    if (responseData && isLoaded) {
      if (responseData[0] === "Rejected") {
        toast.success(rejectedMessage)
        setIsLoaded(false)
      } else if (responseData[0] === "saved") {
        toast.success(approvedMessage)
        setIsLoaded(false)
      } else {
        toast.success(responseData[0])
        setIsLoaded(false)
      }
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [responseData])

  // handle api errors
  useMemo(() => {
    if(!_.isEmpty(errors)) {
      toast.error(errors?.data?.result ? errors?.data?.result[0]: "Error")
    }
  }, [errors])

  // handle delete customer api data
  useEffect(() => {
    if(customerDeletedData && customerDeletedData.length > 0) {
      setResponseDeleteData(customerDeletedData)
    }
  }, [customerDeletedData])

  useEffect(() => {
    if (responseDeleteData && isLoaded) {
      if (responseDeleteData[0] === 'Not Delete') {
        toast.success("Customer not deleted")
        setIsLoaded(false)
      } else {
        toast.success(customerDeletedData[0])
        setIsLoaded(false)
      }
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [responseDeleteData])

  // handle customer role update success
  useEffect(() => {
    if (customerRoleUpdatedData && isLoaded) {
      toast.success(
        Array.isArray(customerRoleUpdatedData) ? customerRoleUpdatedData[0] : "Customer role updated successfully."
      )
      setIsLoaded(false)
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [customerRoleUpdatedData])

  // function called on any filter value change
	const handleFilterChange = (e) => {
		const { id, value } = e.target;
		setListParamState(
			{
				...listParamState,
				[id]: value
			}
		)
	}

  const handlePropertyFilterChange = (e) => {
    const { id, value } = e.target;
    setPropertyFilters(prev => ({ ...prev, [id]: value }));
  }

  // handle approve click
  const handleApproveClick = (data) => {
    setIsLoaded(true)
    updateCustomerApprovalStatus(auth[0].token, data)
  }

  // handle reject click
  const handleRejectClick = (data) => {
    setIsLoaded(true)
    rejectCustomerApprovalRequest(auth[0].token, data)
  }

  //handle customer delete
  const handleDelete = () => {
    setIsLoaded(true)
    if(deleteCustomerData) {
      deleteCustomerApprovalRequest(auth[0].token, deleteCustomerData)
      setDeleteCustomerData({})
      setDeleteCustomerModalOpen(false)
    }
  }

  const handleCustomerDelete = (data) => {
    setDeleteCustomerModalOpen(true);
    setDeleteCustomerData(data);
  }

  // open Edit Role modal, pre-selecting the customer's current role
  const handleEditRoleClick = (data) => {
    const currentRole = customerRoles.find(role => role.roleName === data.role)
    setSelectedRoleId(currentRole ? currentRole.roleId : "")
    setEditRoleData(data)
    setEditRoleModalOpen(true)
  }

  const hideEditRoleModal = () => {
    setEditRoleModalOpen(false)
    setEditRoleData({})
    setSelectedRoleId("")
  }

  const handleEditRoleSave = () => {
    if (editRoleData?.customerSignupId && selectedRoleId) {
      setIsLoaded(true)
      updateCustomerRole(auth[0].token, {
        customerSignupId: editRoleData?.customerSignupId,
        roleId: parseInt(selectedRoleId),
        userId: editRoleData?.userId
      })
      hideEditRoleModal()
    }
  }
  const handleCustomerDeleteSubmit = () => {
    handleDelete()
  }
  
   // Debounce search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm) {
        fetchPropertyAlreadyExist(auth[0].token, searchTerm.toLowerCase())
        // const filtered = allProperties.filter((p) =>
        //   p.propertyName.toLowerCase().includes(searchTerm.toLowerCase())
        // );
        // setFilteredProps(filtered);
      } else {
        setFilteredProps([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  useEffect(() => {
    setFilteredProps(propertyList)
  }, [propertyList])

  useEffect(() => {
    if (!propertyUpdatedData?.length) return;
    // Update newly added property id after adding new property
    setCustomerApprovalData(prev =>
      prev.map((user, idx) =>
        idx === selectedCustomer
          ? {
              ...user,
              customerProperty: [...user.customerProperty, ...propertyUpdatedData]
            }
          : user
      )
    );
    // Pre-select approver role dropdowns for the newly saved properties
    const newRoles = {};
    propertyUpdatedData.forEach(prop => {
      if (prop.customerSignupPropertyId && prop.approverRoleId) {
        newRoles[prop.customerSignupPropertyId] = String(prop.approverRoleId);
      }
    });
    if (Object.keys(newRoles).length > 0) {
      setPropertyApproverRoles(prev => ({ ...prev, ...newRoles }));
    }
    setSelectedCustomer('');
    setTempRows({});
  }, [propertyUpdatedData])

  const handleAddRow = (index) => {
    const newRow = { shipToPropertyName: "", data: {} };
    setTempRows((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), newRow],
    }));
  };

  const hideConfirmDeleteModal = () => {
    setDeletePropertyModalOpen(false)
  }
  const hideCustomerDeleteModal = () => {
    setDeleteCustomerModalOpen(false)
    setDeleteCustomerData({})
  }
  
  const handleConfirmDeleteSubmit = () => {
    const {propertyId, customerIdx} = deletePropertyData;
    if(propertyId){
      deleteCustomerPropertyRequest(auth[0].token, propertyId)
      setCustomerApprovalData(prev =>
        prev.map((user, idx) =>
          idx === customerIdx
            ? {
                ...user,
                customerProperty: user.customerProperty.filter(
                  prop => prop.customerSignupPropertyId !== propertyId
                )
              }
            : user
        )
      );
      setDeletePropertyModalOpen(false)
      setDeletePropertyData({})
    }
  }

  const handleRemoveRow = (delType, index, i=0) => {
    if(delType === 'P'){
      setDeletePropertyData({
        propertyId: index,
        customerIdx: i
      })
      setDeletePropertyModalOpen(true)
    }
    else{
      const updated = [...(tempRows[index] || [])];
      updated.splice(i, 1);
      setTempRows({ ...tempRows, [index]: updated });
    }
  };

  const handlePropertySelect = (rowIndex, prop, userIndex, uData) => {
    const updated = [...(tempRows[userIndex] || [])];
    updated[rowIndex] = { shipToPropertyName: prop.shipToPropertyName, data: prop, customer:uData };
    setTempRows({ ...tempRows, [userIndex]: updated });
    setSearchTerm(""); // Clear after selection
    setFilteredProps([]);
  };

  const handlePropertyRoleChange = (propertyId, roleId) => {
    setPropertyApproverRoles(prev => ({ ...prev, [propertyId]: roleId }));
  };

  const handleTempRowRoleChange = (customerIndex, rowIndex, roleId) => {
    setTempRows(prev => {
      const rows = [...(prev[customerIndex] || [])];
      rows[rowIndex] = { ...rows[rowIndex], approverRoleId: roleId };
      return { ...prev, [customerIndex]: rows };
    });
  };

  const handleSaveApprover = async (customerIndex, data) => {
    const existingWithRoles = (data.customerProperty || [])
      .filter(prop => propertyApproverRoles[prop.customerSignupPropertyId])
      .map(prop => ({
        customerSignupPropertyId: prop.customerSignupPropertyId,
        ApproverRoleId: parseInt(propertyApproverRoles[prop.customerSignupPropertyId])
      }));

    const tempWithRoles = (tempRows[customerIndex] || [])
      .filter(row => row.approverRoleId)
      .map(row => ({
        propertyName: row.data?.shipToPropertyName || "",
        ApproverRoleId: parseInt(row.approverRoleId)
      }));

    if (existingWithRoles.length === 0 && tempWithRoles.length === 0) {
      toast.error("Please select an approver role for at least one property.");
      return;
    }

    const payload = {
      customerSignupId: data.customerSignupId,
      propertyApprovers: existingWithRoles,
      ...(tempWithRoles.length > 0 && { pendingPropertyApprovers: tempWithRoles })
    };

    try {
      const response = await axios.post(
        `${API_URL}/User/api/Signup/SavePropertyApprover`,
        payload,
        { headers: { Authorization: `Bearer ${auth[0].token}` } }
      );
      toast.success(
        response?.data?.responsestatus === 'Success'
          ? "Approver roles saved successfully."
          : response?.data?.message || "Approver roles saved successfully."
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.result?.[0] ||
        err?.response?.data?.message ||
        "Failed to save approver roles. Please try again."
      );
    }
  };

  const handleSave = (userIndex) => {
    const rowsToSave = tempRows[userIndex];

    const selectedRows = rowsToSave.filter(item => item?.customer?.customerSignupId);

    const missingRole = selectedRows.some(item => !item.approverRoleId);
    if (missingRole) {
      toast.error("Please select an approver role for all properties before saving.");
      return;
    }

    const newPropList = selectedRows.map(item => ({
      CustomerSignupId: item.customer.customerSignupId,
      PropertyName: item.data.shipToPropertyName,
      ManagementCompany: item.data.shipToManagementCompany,
      Address: item.data.shipToAddress,
      City: item.data.shipToCity,
      State: item.data.shipToState,
      Zip: item.data.shipToZip,
      PhoneNo: item.data.shipToPhone,
      ContactInfoID: item.data.contactInfoId,
      ApproverRoleId: parseInt(item.approverRoleId),
    }));

    if(newPropList.length > 0){
      let tmpList = {
        'CustomerProperty': newPropList
      };
      setSelectedCustomer(userIndex)
      addNewProperty(auth[0].token, tmpList)
    }
  };

  return (
    <Fragment>
      <MainWrapper>
      {isLoading ? (<div className="loading-container"><div className="spinner-border"></div></div>) : null}
      <div className="container">
        <div className="sub-header mt-5 mb-3">
          <h2>Customer approval</h2>
          <Link className="btn btn-primary me-1" to="/dashboard"><Icon icon={ic_arrow_back} />Back</Link>
        </div>
        
        <div className="p-3 bg-light customer-approval-filter">
          <Row>
            <Col md><Input label={`First Name`} ids={`firstName`} value={listParamState.firstName} validate={false} handleChange={handleFilterChange} /></Col>
            <Col md><Input label={`Last Name`} ids={`lastName`} value={listParamState.lastName} validate={false} handleChange={handleFilterChange} /></Col>
            <Col md><Input label={`Email`} ids={`email`} value={listParamState.email} validate={false} handleChange={handleFilterChange} /></Col>
            <Col md><Input label={`Property Name`} ids={`propertyName`} value={propertyFilters.propertyName} validate={false} handleChange={handlePropertyFilterChange} /></Col>
            <Col md><Input label={`Management Company`} ids={`managementCompany`} value={propertyFilters.managementCompany} validate={false} handleChange={handlePropertyFilterChange} /></Col>
          </Row>
        </div>
        {!_.isEmpty(filteredCustomerApprovalData) ? (
          <div className="px-3 py-2 fw-semibold text-muted border-bottom" style={{ paddingRight: "2.75rem" }}>
            <Row className="gx-2 mx-0 align-items-center">
              <Col md={2}>First Name</Col>
              <Col md={2}>Last Name</Col>
              <Col md={4}>Email</Col>
              <Col md={2}>Role</Col>
              <Col md={2} className="text-end">Status</Col>
            </Row>
          </div>
        ) : null}
        <Accordion defaultActiveKey="0">
          {!_.isEmpty(filteredCustomerApprovalData) ? _.map(filteredCustomerApprovalData, (item) => {
            const { sourceIndex: customerIndex, ...data } = item;

            return (
            <Accordion.Item eventKey={customerIndex} key={data.customerSignupId || customerIndex}>
              <Accordion.Header>
                <Row className="w-100 gx-2 mx-0 align-items-center">
                  <Col md={2}>{data.firstName}</Col>
                  <Col md={2}>{data.lastName}</Col>
                  <Col md={4} className="text-break">{data.email}</Col>
                  <Col md={2}>{data.role}</Col>
                  <Col md={2} className="text-end">
                    <span className={`badge ${getStatusBadgeClass(data.status)}`}>
                      {_.get(data, "status", "")}
                    </span>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body>
                <Table bordered responsive className="mb-3">
                  <thead>
                    <tr>
                      <th>Property Name</th>
                      <th>Management Company</th>
                      <th>Address</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Zip</th>
                      <th>Phone No.</th>
                      <th>Approver Role</th>
                      <th></th>
                    </tr>
                  </thead>
                    <tbody>
                      {!_.isEmpty(data.customerProperty) ? _.map(data.customerProperty, (value, position) => (
                      <tr key={position}>
                        <td>{_.get(value, "propertyName", "")}</td>
                        <td>{_.get(value, "managementCompany", "")}</td>
                        <td>{_.get(value, "address", "")}</td>
                        <td>{_.get(value, "city", "")}</td>
                        <td>{_.get(value, "state", "")}</td>
                        <td>{_.get(value, "zip", "")}</td>
                        <td>{_.get(value, "phoneNo", "")}</td>
                        <td>
                          <Form.Select
                            size="sm"
                            value={propertyApproverRoles[value.customerSignupPropertyId] || ""}
                            onChange={e => handlePropertyRoleChange(value.customerSignupPropertyId, e.target.value)}
                          >
                            <option value="">Select Role</option>
                            {customerRoles.map(role => (
                              <option key={role.roleId} value={role.roleId}>{role.roleName}</option>
                            ))}
                          </Form.Select>
                        </td>
                        <td>
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleRemoveRow('P', value.customerSignupPropertyId, customerIndex)}
                          />
                        </td>
                      </tr>
                      )) : ""}
                      {(tempRows[customerIndex] || []).map((row, i) => (
                        <tr key={`new-${i}`}>
                          <td>
                            {row.shipToPropertyName ? (
                              row.shipToPropertyName
                            ) : (
                              <>
                                <Form.Control
                                  type="text"
                                  placeholder="Search property"
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {filteredProps.length > 0 && (
                                  <div
                                    style={{
                                      background: "#f9f9f9",
                                      position: "absolute",
                                      zIndex: 1000,
                                      border: "1px solid #ccc",
                                      width: "200px",
                                    }}
                                  >
                                    {filteredProps.map((prop, idx) => {
                                      const alreadySaved = (data.customerProperty || []).some(p =>
                                        p.contactInfoId && prop.contactInfoId
                                          ? p.contactInfoId === prop.contactInfoId
                                          : (p.propertyName || "").toLowerCase() === (prop.shipToPropertyName || "").toLowerCase()
                                      );
                                      const alreadyInTemp = (tempRows[customerIndex] || []).some(
                                        (r, ri) => ri !== i && r.data?.contactInfoId === prop.contactInfoId
                                      );
                                      const isDisabled = alreadySaved || alreadyInTemp;
                                      return (
                                        <div
                                          key={idx}
                                          style={{
                                            padding: "4px 8px",
                                            cursor: isDisabled ? "not-allowed" : "pointer",
                                            color: isDisabled ? "#aaa" : "inherit",
                                            backgroundColor: isDisabled ? "#f0f0f0" : "transparent",
                                          }}
                                          onClick={() => !isDisabled && handlePropertySelect(i, prop, customerIndex, data)}
                                        >
                                          {prop.shipToPropertyName}
                                          {isDisabled && <span style={{ fontSize: "0.75em", marginLeft: "6px" }}>(Already added)</span>}
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </>
                            )}
                          </td>
                          <td>{row.data?.shipToManagementCompany || ""}</td>
                          <td>{row.data?.shipToAddress || ""}</td>
                          <td>{row.data?.shipToCity || ""}</td>
                          <td>{row.data?.shipToState || ""}</td>
                          <td>{row.data?.shipToZip || ""}</td>
                          <td>{row.data?.shipToPhone || ""}</td>
                          <td>
                            <Form.Select
                              size="sm"
                              value={row.approverRoleId || ""}
                              onChange={e => handleTempRowRoleChange(customerIndex, i, e.target.value)}
                            >
                              <option value="">Select Role</option>
                              {customerRoles.map(role => (
                                <option key={role.roleId} value={role.roleId}>{role.roleName}</option>
                              ))}
                            </Form.Select>
                          </td>
                          <td>
                            <FaTrash
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => handleRemoveRow('T', customerIndex, i)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                </Table>
                <div className="mb-3">
                  <Button
                    variant="success"
                    className="me-2"
                    onClick={() => handleAddRow(customerIndex)}
                  >
                    Add Property
                  </Button>
                  {(data.customerProperty?.length > 0) && !(tempRows[customerIndex]?.length > 0) && (
                    <Button
                      variant="warning"
                      className="me-2"
                      onClick={() => handleSaveApprover(customerIndex, data)}
                    >
                      Save Approver
                    </Button>
                  )}
                  {tempRows[customerIndex]?.length > 0 && (
                    <Button
                      variant="primary"
                      className="me-2"
                      onClick={() => handleSave(customerIndex)}
                    >
                      Save
                    </Button>
                  )}
                </div>
                <div>
                  Status: {_.get(data, "status", "")}
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div>
                    <Button className="me-2" variant="primary" disabled={data?.status === "Pending Request" ? false : true} onClick={()=>handleApproveClick(data)}>Approve</Button>
                    <Button className="me-2" variant="secondary" disabled={data?.status === "Pending Request" ? false : true} onClick={()=>handleRejectClick(data)}>Reject</Button>
                    <Button className="me-2" variant="danger" onClick={()=>handleCustomerDelete(data)}>Delete</Button>
                    <Button className="me-2" variant="info" onClick={()=>handleEditRoleClick(data)}>Edit Role</Button>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0">Set Approver:</Form.Label>
                    <Form.Select
                      style={{ width: 'auto', minWidth: '200px' }}
                      value={selectedApprovers[customerIndex] || ""}
                      onChange={(e) => setSelectedApprovers(prev => ({ ...prev, [customerIndex]: e.target.value }))}
                    >
                      <option value="">-- Select --</option>
                      {approvedUsers.map(user => (
                        <option key={user.customerSignupId} value={user.customerSignupId}>
                          {`${user.firstName || ""} ${user.lastName || ""}`.trim() || user.email}
                        </option>
                      ))}
                    </Form.Select>
                    <Button
                      variant="primary"
                      disabled={!selectedApprovers[customerIndex]}
                    >
                      Assign
                    </Button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            );
          }) : null
          }
        </Accordion>
      </div>
      {deletePropertyModalOpen ?
        <ConfirmModal
          show={deletePropertyModalOpen}
          onHide={hideConfirmDeleteModal}
          onConfirm={handleConfirmDeleteSubmit}
          title="Remove Customer Property?"
          message="Are you sure?"
          dangerNote="Access to this property will be removed for this customer."
        /> : ""
      }
      {deleteCustomerModalOpen ?
        <ConfirmModal
          show={deleteCustomerModalOpen}
          onHide={hideCustomerDeleteModal}
          onConfirm={handleCustomerDeleteSubmit}
          title="Delete Customer?"
          message="Are you sure?"
          dangerNote="* Customer will be deleted."
        /> : ""
      }
      {editRoleModalOpen ?
        <EditRoleModal
          show={editRoleModalOpen}
          onHide={hideEditRoleModal}
          onSave={handleEditRoleSave}
          roles={customerRoles}
          selectedRoleId={selectedRoleId}
          onRoleChange={setSelectedRoleId}
          customerName={`${editRoleData?.firstName ?? ""} ${editRoleData?.lastName ?? ""}`.trim()}
        /> : ""
      }
      </MainWrapper>
    </Fragment>
  )
}

const mapStateToProps = ({ auth, CustomerApproval, Role }) => {
  return {
    auth, CustomerApproval, Role
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomerApprovalList: (token, listParamState) => dispatch({ type: CUSTOMER_APPROVAL_LIST_REQUEST, token, listParamState }),
    updateCustomerApprovalStatus: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_UPDATE_REQUEST, token, data }),
    rejectCustomerApprovalRequest: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_REJECT_REQUEST, token, data }),
    deleteCustomerApprovalRequest: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_DELETE_REQUEST, token, data }),
    fetchPropertyAlreadyExist: (token, data) => dispatch({ type: PROPERTY_LIST_REQUEST, token, data }),
    addNewProperty: (token, data) => dispatch({ type: ADD_NEW_PROPERTY_REQUEST, token, data }),
    deleteCustomerPropertyRequest: (token, data) => dispatch({ type: CUSTOMER_PROPERTY_DELETE_REQUEST, token, data }),
    fetchRoleList: (token) => dispatch({ type: ROLE_LIST_REQUEST, token }),
    updateCustomerRole: (token, data) => dispatch({ type: CUSTOMER_ROLE_UPDATE_REQUEST, token, data })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerApproval);
